import { cn } from '@/shared/ui/primitives'

/**
 * Where a document is on its ladder, as a row of short bars: green for passed
 * levels, blue for the current one, grey for those ahead. Drawn from the
 * numbers it is given, never from an assumed number of levels.
 */
export function LevelBars({ level, of, withLabel = false }: { level: number; of: number; withLabel?: boolean }) {
  return (
    <span className="inline-flex items-center gap-2 whitespace-nowrap">
      <span className="inline-flex items-center gap-[3px]" aria-label={`Level ${level} dari ${of}`} role="img">
        {Array.from({ length: Math.max(of, 1) }, (_, index) => (
          <i
            key={index}
            className={cn(
              'h-1.5 w-4 rounded-full',
              index + 1 < level ? 'bg-success' : index + 1 === level ? 'bg-primary' : 'bg-gray-200',
            )}
          />
        ))}
      </span>
      {withLabel && (
        <small className="text-xs text-gray-500">
          Level {level} dari {of}
        </small>
      )}
    </span>
  )
}
